import AbstractFormulaVisitor from "../../models/keyFigure/formula/visitors/AbstractFormulaVisitor.js";

/**
 * Generate an array of items from a formula as expected by
 * `StackEditorWidget`.
 */
export default class FormulaStackTagCreator extends AbstractFormulaVisitor {
	constructor({ report }) {
		super(...arguments);

		this._report = report;
	}

	visitNaNode() {
		return [];
	}

	visitBinaryOperatorNode(node) {
		return [
			...node.getLeftOperand().accept(this),
			{ label: node.getLabel() },
			...node.getRightOperand().accept(this),
		];
	}

	visitSumNode(node) {
		return node
			.getOperands()
			.flatMap((operand) => [...operand.accept(this), { label: "+" }])
			.slice(0, -1); // remove final "+"
	}

	visitReportReferenceNode(node) {
		const reportItem = this._report.findItemWithTemplate(
			node.getReference(),
		);

		const label = reportItem
			? reportItem.getTitle()
			: node.getReferenceLabel();

		return [
			{
				label,
				cssClass: node.isValid() ? "" : "invalid",
			},
		];
	}
}
